// components/RefundRequests.js
import React from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { getRefundRequests, deleteRefundRequest, updateRefundRequestStatus } from '../../services/refundService';
import { useNavigate } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';
import 'tailwindcss/tailwind.css';

const RefundRequests = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data, error, isLoading } = useQuery('refundRequests', getRefundRequests);
console.log(data)
  const deleteMutation = useMutation(deleteRefundRequest, {
    onSuccess: () => {
      queryClient.invalidateQueries(['refundRequests']);
    },
  });

  const updateStatusMutation = useMutation(updateRefundRequestStatus, {
    onSuccess: () => {
      queryClient.invalidateQueries(['refundRequests']);
    },
  });

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  const handleRefundClick = (refundRequest) => {
    if (refundRequest.user) {
      navigate(`/dashboard/admin/users/${refundRequest.user._id}`);
    }
  };

  const handleDelete = (id) => {
    deleteMutation.mutate(id);
  };

  const handleStatusUpdate = (id) => {
    updateStatusMutation.mutate({ id, status: 'completed' });
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Refund Requests</h1>
      <table className="min-w-full bg-white border border-gray-200">
        <thead>
          <tr>
            <th className="py-2 px-4 border-b">User</th>
            <th className="py-2 px-4 border-b">Status</th>
            <th className="py-2 px-4 border-b">Requested</th>
            <th className="py-2 px-4 border-b">date</th>

            <th className="py-2 px-4 border-b">Actions</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((request) => (
            <tr
              key={request._id}
              className={`cursor-pointer ${
                request.status === 'pending' ? 'bg-orange-100 hover:bg-orange-200' : 'bg-green-100 hover:bg-green-200'
              }`}
              onClick={() => handleRefundClick(request)}
            >
              <td className="py-2 px-4 border-b">{request.user ? request.user.name : 'Unknown'}</td>
              <td className="py-2 px-4 border-b">{request.status}</td>
              <td className="py-2 px-4 border-b">{formatDistanceToNow(new Date(request.requestDate))} ago</td>
              <td>{new Date(request?.createdAt).toLocaleString()}</td>

              <td className="py-2 px-4 border-b">
                {request.status === 'pending' && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleStatusUpdate(request._id);
                    }}
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded mr-2"
                  >
                    Mark as Completed
                  </button>
                )}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDelete(request._id);
                  }}
                  className="bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-2 rounded"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RefundRequests;
